var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdd = function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.786 3.75a.75.75 0 0 1 .75.75v5.249h5.25l.077.004a.75.75 0 0 1 0 1.492l-.077.004h-5.25V16.5a.75.75 0 0 1-1.5 0v-5.251h-5.25a.75.75 0 0 1 0-1.5h5.25V4.5a.75.75 0 0 1 .75-.75"
  })));
};
export default SvgIconAdd;